import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { Tooltip } from "antd";
import { canVisitModule } from "../../../../utils/permission";
import { WORKSPACE_URLS } from "../../../../constants/workspaceUrls";
import { message } from "../../../../components/Message";
import cnServiceStyles from "../../../../components/Service/index.modules.less";
import styles from "./index.modules.less";

const buildItems = ({ setOpen, identityType, permissionCodes }) => {
  const isSubAccount = identityType === "sub_account";
  const hasComplaint = canVisitModule({
    identityType,
    permissionCodes,
    requiredPermission: "complaint_handling",
  });

  return [
    {
      title: "添加软件 >",
      desc: "添加到软件管家",
      cn: "addSoft",
      image: "https://p0.ssl.qhimg.com/t018f6e37e0f593edc7.png",
      visible: true,
      click: () => setOpen(true),
    },
    {
      title: "数据服务 >",
      desc: "查询流水、结算",
      cn: "dataService",
      image: "https://p5.ssl.qhimg.com/t01a8b0c5ed115bba55.png",
      visible: !isSubAccount,
      click: () => {
        if (!WORKSPACE_URLS.intlDataService) {
          message.show({ type: "info", content: "国际数据服务链接待产品配置（PRD-03）" });
          return;
        }
        window.open(WORKSPACE_URLS.intlDataService);
      },
    },
    {
      title: "文档中心 >",
      desc: "接入文档、帮助",
      cn: "help",
      image: "https://p0.ssl.qhimg.com/t01e9cc89e9bd06093c.png",
      visible: !isSubAccount,
      click: () => {
        if (!WORKSPACE_URLS.intlDocCenter) {
          message.show({ type: "info", content: "国际文档中心待产品配置（PRD-12）" });
          return;
        }
        window.open(WORKSPACE_URLS.intlDocCenter);
      },
    },
    {
      title: "用户投诉 >",
      desc: "回复用户、退款",
      cn: "complaints",
      image: "https://p5.ssl.qhimg.com/t11b673bcd60ccdc047e429acba.png",
      visible: !isSubAccount || hasComplaint,
      disabled: true,
      tip: "国际客诉能力本期未开放",
      click: () => {},
    },
  ];
};

const IntlService = ({ setOpen, identityType, permissionCodes }) => {
  const [isShowAnnouncement, updateIsShowAnnouncement] = useState(false);

  useEffect(() => {
    const endDate = new Date("2025/02/05");
    const now = new Date();
    updateIsShowAnnouncement(now < endDate);
  }, []);

  const items = buildItems({ setOpen, identityType, permissionCodes }).filter(
    (item) => item.visible
  );

  return (
    <div className={cnServiceStyles.wrapper}>
      <div className={cnServiceStyles.titleWrapper}>
        <h1 className={cnServiceStyles.title}>联运服务（国际）</h1>
        {isShowAnnouncement && (
          <div className={cnServiceStyles.announcement}>
            尊敬的合作厂商，软件管家将于春节假期期间暂停联运软件收录审核，感谢您的理解与支持。
          </div>
        )}
      </div>
      <div className={cnServiceStyles.content}>
        {items.map((item, index) => {
          const card = (
            <div
              onClick={item.disabled ? undefined : item.click}
              className={classNames(cnServiceStyles.item, {
                [cnServiceStyles.dataService]: item.cn === "dataService",
                [cnServiceStyles.help]: item.cn === "help",
                [cnServiceStyles.complaints]: item.cn === "complaints",
                [styles.disabledCard]: item.disabled,
              })}
              key={index}
            >
              <div className={cnServiceStyles.itemTitleContent}>
                <span className={cnServiceStyles.itemTitle}>{item.title}</span>
                <span className={cnServiceStyles.itemDesc}>{item.desc}</span>
              </div>
              <div className={cnServiceStyles.icon} alt="">
                <div className={cnServiceStyles.image}>
                  <img className={cnServiceStyles.img} src={item.image} alt="" />
                </div>
              </div>
            </div>
          );

          if (item.disabled && item.tip) {
            return (
              <Tooltip key={index} title={item.tip}>
                {card}
              </Tooltip>
            );
          }

          return card;
        })}
      </div>
    </div>
  );
};

export default IntlService;
